import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { APIClient } from "../../helpers/api_helper";

const apiClient = new APIClient();

// Normalize API error to a single string for toast (backend may return message as string or array)
const getErrorMessage = (error, fallback) => {
  const msg = error?.message ?? error?.data?.message;
  if (Array.isArray(msg)) return msg.join(" ");
  if (typeof msg === "string") return msg;
  if (msg && typeof msg === "object") return JSON.stringify(msg);
  return fallback;
};

export const getRoles = createAsyncThunk("roles/getRoles", async () => {
  try {
    const response = await apiClient.get("/roles");
    return response;
  } catch (error) {
    toast.error(getErrorMessage(error, "Failed to fetch roles"), { autoClose: 5000 });
    throw error;
  }
});

export const getRoleById = createAsyncThunk("roles/getRoleById", async (id) => {
  try {
    const response = await apiClient.get(`/roles/${id}`);
    return response;
  } catch (error) {
    toast.error(getErrorMessage(error, "Failed to fetch role"), { autoClose: 5000 });
    throw error;
  }
});

export const addNewRole = createAsyncThunk("roles/addNewRole", async (roleData) => {
  try {
    const response = await apiClient.create("/roles", roleData);
    toast.success("Role Added Successfully", { autoClose: 3000 });
    return response;
  } catch (error) {
    toast.error(getErrorMessage(error, "Failed to add role"), { autoClose: 5000 });
    throw error;
  }
});

export const updateRole = createAsyncThunk("roles/updateRole", async ({ id, roleData }) => {
  try {
    const response = await apiClient.put(`/roles/${id}`, roleData);
    toast.success("Role Updated Successfully", { autoClose: 3000 });
    return response;
  } catch (error) {
    toast.error(getErrorMessage(error, "Failed to update role"), { autoClose: 5000 });
    throw error;
  }
});

export const deleteRole = createAsyncThunk("roles/deleteRole", async (id) => {
  try {
    await apiClient.delete(`/roles/${id}`);
    toast.success("Role Deleted Successfully", { autoClose: 3000 });
    return { id };
  } catch (error) {
    toast.error(getErrorMessage(error, "Failed to delete role"), { autoClose: 5000 });
    throw error;
  }
});
